/**
 * Collection Description Toggle
 * Permet de déplier/replier la description de collection
 */

$(document).ready(function() {
  // Toggle la classe "open" sur le conteneur au clic sur la flèche
  $(".description-toggle").click(function () {
    $(this).parents(".collection-description-container").toggleClass("open");
  });
});
